import React, { ChangeEvent, FocusEvent } from 'react';
import { Input, Label, LabelSpan, RadioIcon } from '../../../components/Form';
import { Column, Row } from '../../../components/Grid';
import Typo3Label from '../../../provider/Typo3Provider/Typo3Label';

interface GenderSelectProps {
  value: 'F' | 'M';
  handleChange: (e: ChangeEvent<any>) => any;
  handleBlur: (e: FocusEvent) => any;
  error: boolean;
}

const GenderSelect = ({
  value,
  handleChange,
  handleBlur,
  // currently ignored, as there is a default value for gender
  error
}: GenderSelectProps) => (
  <Label>
    <LabelSpan required>
      <Typo3Label label="form.label.salutation" />
    </LabelSpan>
    <Row noGap justifyContent="left">
      <Column large={3}>
        <Label radio>
          <Input
            inlined
            type="radio"
            name="codeSalutation"
            value="M"
            checked={value === 'M'}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <RadioIcon />
          <Typo3Label label="form.label.salutation.him" />
        </Label>
      </Column>
      <Column large={3}>
        <Label radio>
          <Input
            inlined
            type="radio"
            name="codeSalutation"
            value="F"
            checked={value === 'F'}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <RadioIcon />
          <Typo3Label label="form.label.salutation.her" />
        </Label>
      </Column>
    </Row>
  </Label>
);

export default GenderSelect;
